module.exports = __webpack_public_path__ + "static/fonts/Alibaba-PuHuiTi-R.77305a8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Alibaba-PuHuiTi-R.woff
// module id = gees
// module chunks = 52